import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from "rxjs";

import { ISidebarConfig } from "../helper/ISidebarConfig";

@Injectable({
    providedIn: 'root',
})
export class SidebarService {

    private contextObservables = new BehaviorSubject<Observable<ISidebarConfig>>(of({show: false}));

    public context: BehaviorSubject<ISidebarConfig>;

    public next(context: ISidebarConfig) {
       // this.contextObservables.next(of(context));
        this.context.next(context);
    }

    constructor() {
        this.context = new BehaviorSubject<ISidebarConfig>({show: false});
    }


}
